import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { applyThemePreference } from "./ds";
import { App } from "./App";
import { FleetPage } from "./pages/FleetPage";
import { DevicePage } from "./pages/DevicePage";
import { ImagesPage } from "./pages/ImagesPage";
import { ApprovalsPage } from "./pages/ApprovalsPage";
import { AuditPage } from "./pages/AuditPage";
import { SchedulePage } from "./pages/SchedulePage";
import { WireguardPage } from "./pages/WireguardPage";
import { BlocklistPage } from "./pages/BlocklistPage";
import { BackupsPage } from "./pages/BackupsPage";
import "./styles/index.css";

// Theme früh setzen (data-theme auf <body>), bevor React malt → kein Flash.
applyThemePreference("auto");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route element={<App />}>
            <Route index element={<Navigate to="/fleet" replace />} />
            <Route path="/fleet" element={<FleetPage />} />
            <Route path="/fleet/:deviceId" element={<DevicePage />} />
            <Route path="/approvals" element={<ApprovalsPage />} />
            <Route path="/images" element={<ImagesPage />} />
            <Route path="/schedule" element={<SchedulePage />} />
            <Route path="/wireguard" element={<WireguardPage />} />
            <Route path="/backups" element={<BackupsPage />} />
            <Route path="/blocklist" element={<BlocklistPage />} />
            <Route path="/audit" element={<AuditPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
